var React = require('react');

function BackArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2138.112,27.682,2124.7,41.1l13.123,13.123","transform":"translate(-2122.576 -26.622)","fill":"none","stroke":"#f9f9f9","strokeWidth":"3"}));
}

BackArrow.defaultProps = {"focusable":"false","width":"16.597","height":"28.66","viewBox":"0 0 16.597 28.66"};

module.exports = BackArrow;

BackArrow.default = BackArrow;
